<template>
  <div class="form-group">
    <label :for="'input' + inputID" class="text-label">
      <input
        type="checkbox"
        :id="'input' + inputID"
        v-model="checked"
        @change="emitChange"
      />&nbsp;{{ label }}
    </label>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import newId from '../../utils/unique_key'; // Adjust the import path as needed

export default {
  name: 'Checkbox',
  props: {
    label: {
      type: String,
      required: true,
      default: ''
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const checked = ref(props.modelValue);
    const inputID = newId();
   
    watch(() => props.modelValue, (newValue) => {
      checked.value = newValue;
    });

    const emitChange = () => {
      emit('update:modelValue', checked.value);
    };

    return { checked, inputID, emitChange };
  }
};
</script>
